module.exports = __webpack_public_path__ + "static/img/banner-fabric-2.f5a746e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/layout/banner/en/banner-fabric-2.jpg
// module id = 512
// module chunks = 63